<div class="container">
  <!--Page title and search icon-->
  <div
    fxLayout="row">
    <div fxFlex="20%">
      <div class="form-page-name-search">
        Home
      </div>
    </div>
    <div fxFlex="80%">
      <div style="float: right">
        <div style="margin-top: 6px;">
          <form [formGroup]="formSearch">
            <mat-form-field [hidden]="!displaySearchInput"
              class="form-page-name-search-input"
              floatLabel='never' >
              <input matInput #searchPhrase="matInput"
                id="searchPhrase"
                name="searchPhrase"
                formControlName="searchPhrase"
                placeholder="Search by name or address">
            </mat-form-field>
            <div style="display: inline-block" class="form-page-name-search-icon">
              <button mat-icon-button
                matTooltip="Search by name or address"
                [matTooltipPosition]="'above'"
                (click)="onClickSearchIcon()">
                <mat-icon color="primary">search</mat-icon>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!--Page tool bar-->
  <div *ngIf="!isContractor()" style="margin-top: 15px;">
    <mat-toolbar class="form-toolbar"
      fxShow.gt-sm fxHide.lt-md>
      <span class="form-action-title">
          Applications
      </span>
      <span class="form-toolbar-spacer"></span>
        <a *ngIf="!isInspector() && multipleAppsAllowed() === 2"
            class="form-action-task"
            href="{{uriSpaRegistration}}">
          Register another property
        </a>
        <div *ngIf="isInspector()">
          <span class="form-toolbar-spacer"></span>
          <div class="form-action-task" style="display:inline">
            <a *ngIf="toggleInspectedProjects"
              class="form-action-task"
              href="javascript:void(0)"
              (click)="onClickToggleInspectedProjects()">
              View Open Projects
            </a>
            <a *ngIf="!toggleInspectedProjects"
              class="form-action-task"
              href="javascript:void(0)"
              (click)="onClickToggleInspectedProjects()">
              View Completed Projects
            </a>
          </div>
        </div>
    </mat-toolbar>
    <div fxHide.gt-sm fxShow.lt-md>
      <div>
        <div class="form-action-title">Applications</div>
        <div *ngIf="!isInspector()" style="display:inline;">
          <div class="form-action-task">
            <a
              class="form-action-task"
              href="javascript:void(0)"
              matTooltip="Actions"
              [matTooltipPosition]="'below'"
              [matMenuTriggerFor]="menu">
              ACTIONS
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngIf="!isContractor() && multipleAppsAllowed() === 2"
              (click)='goToUrl(uriSpaRegistration)'>
                <span>Register Another Property</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>

  <div *ngIf="isContractor()" 
        style="margin-top: 15px;">
    <mat-toolbar class="form-toolbar">
      <div class="form-action-title">
        Projects
      </div>
      <span class="form-toolbar-spacer"></span>
      <div class="form-action-task" style="display:inline">
        <a *ngIf="toggleOpenClosedProjects"
          class="form-action-task"
          href="javascript:void(0)"
          (click)="onClickToggleOpenClosedProjects()">
          View completed projects
        </a>
        <a *ngIf="!toggleOpenClosedProjects"
          class="form-action-task"
          href="javascript:void(0)"
          (click)="onClickToggleOpenClosedProjects()">
          View open projects
        </a>
      </div>

      <div *ngIf="isContractor()" 
            class="form-action-task" 
            style="margin-left: 15px;">
        <a href="javascript:void(0)"
          class="form-action-task"
          matTooltip="Click to change display"
          [matTooltipPosition]="'below'"
          [matMenuTriggerFor]="menuToggleDisplay">
          <span *ngIf="toggleDisplayCardList">
            View as cards
          </span>
          <span *ngIf="!toggleDisplayCardList">
            View as list
          </span>
          <mat-menu #menuToggleDisplay='matMenu'>
            <button mat-menu-item (click)="toggleHomeDisplayMode(true)">
              <mat-icon>view_module</mat-icon>
              <span>View as cards</span>
            </button>
            <button mat-menu-item (click)="toggleHomeDisplayMode(false)">
              <mat-icon>view_stream</mat-icon>
              <span>View as list</span>
            </button>
          </mat-menu>
        </a>
      </div>
    </mat-toolbar>
  </div>

  <!--Contractor onboarding-->
  <div *ngIf="currentContact?.isContractor && !currentContact?.femaTrained"
    style="margin-top: 18px;">
    <mat-card>
      <mat-card-title>
        Getting Started
      </mat-card-title>

      <div style="margin-top:21px;">
          <h6>
            FEMA Training
          </h6>
          <div class="retrofit-form-text">
            <div [innerHTML]="textFemaTrainingContractor"></div>
          </div>

          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex='25%'>
              <a mat-stroked-button color="primary"
              (click)="redirectToEBBTraining()">
                GO TO BRACE BOLT COURSE
              </a>

              <div class="retrofit-form-inline-icon-with-label-container" style="margin-top: 12px;">
                <div *ngIf="currentContact?.femaTrained else showIncompleteTraining">
                  <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">
                    assignment_turned_in
                  </mat-icon>
                  <span class="retrofit-form-inline-icon-with-label-text">
                    Course Completed
                  </span>
                </div>
                <ng-template #showIncompleteTraining>
                  <mat-icon class="retrofit-form-inline-icon-with-label" color="warn">
                    assignment_late
                  </mat-icon>
                  <span class="retrofit-form-inline-icon-with-label-text">
                    Course Incomplete
                  </span>
                </ng-template>
              </div>
            </div>

            <div fxFlex='25%' class="ess-content">
              <a mat-stroked-button color="primary"
              (click)="redirectToESSTraining()">
                GO TO SOFT STORY COURSE
              </a>

              <div class="retrofit-form-inline-icon-with-label-container" style="margin-top: 12px;">
                <div *ngIf="currentContact?.essFemaTrained else showIncompleteTraining">
                  <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">
                    assignment_turned_in
                  </mat-icon>
                  <span class="retrofit-form-inline-icon-with-label-text">
                    Course Completed
                  </span>
                </div>
                <ng-template #showIncompleteTraining>
                  <mat-icon class="retrofit-form-inline-icon-with-label" color="warn">
                    assignment_late
                  </mat-icon>
                  <span class="retrofit-form-inline-icon-with-label-text">
                    Course Incomplete
                  </span>
                </ng-template>
              </div>
            </div>
          </div>
            
      </div>
    </mat-card>
  </div>

  <!--User profile update-->
  <div *ngIf="currentUser?.needsProfileUpdate"
    style="margin-top: 18px;">
    <mat-card>
      <mat-card-title>
        Updating Your Profile
      </mat-card-title>

      <div style="margin-top:21px;">
          <div class="retrofit-form-text">
            <div [innerHTML]="textProfileNeedsUpdate"></div>
          </div>
      </div>
      <div style="margin-top: 12px;">
        <a mat-stroked-button color="primary" [routerLink]="['/account']">
          COMPLETE PROFILE
        </a>
    </div>
    </mat-card>
  </div>
  <div [hidden]="ShowNewApplications() && currentContact ==null" *ngIf="!isContractorLicenseIsValid()&& isContractor() && toggleOpenClosedProjects" style="margin-top: 9px; margin-left: 15px;">
    <p>The California Residential Mitigation Program (CRMP) has been notified of an issue with your Contractor License Status.
       <br>You will not be able to proceed with any CRMP retrofits until your license issue is resolved and in good standing.
       <br>Please contact the Contractors State License Board at (800) 321-CSLB (2752).</p>
  </div>
  <!-- NEW PROJECTS -->
  <ebb-portal-new-application-list
    [data]='newApplications'
    [ShowNewApplications]='ShowNewApplications()'
    [femareviewmessage]='femareviewmessage'
    [currentUser]='currentUser'
    [toggleDisplayCardList]='toggleDisplayCardList'
    (emitapplicationChangeEvent)="onEmitApplicationChangeEvent($event)">
  </ebb-portal-new-application-list>

  <!-- OPEN PROJECTS (and all inspectors open/closed) -->
  <ebb-portal-open-application-list [data]='activeApplications' [ShowOpenApplications]='ShowOpenApplications()' [femareviewmessage]='femareviewmessage'
    [currentUser]='currentUser' [currentContact]='currentContact' [toggleDisplayCardList]='toggleDisplayCardList'
    [checkForOpenApplications]='checkForOpenApplications' [ShowOpenApplicationsMessage]='ShowOpenApplicationsMessage()'
    [toggleOpenClosedProjects]='toggleOpenClosedProjects'>
  </ebb-portal-open-application-list>

  <!-- CLOSED PROJECTS -->
  <ebb-portal-close-application-list
    [data]='closedApplications'
    [ShowClosedApplications]='ShowClosedApplications()'
    [currentUser]='currentUser'
    [toggleDisplayCardList]='toggleDisplayCardList'
    [checkForClosedApplications]='checkForClosedApplications'
    [ShowClosedApplicationsMessage]='ShowClosedApplicationsMessage()'
    [toggleOpenClosedProjects]='toggleOpenClosedProjects'>
  </ebb-portal-close-application-list>

  <!--WAITLIST DWELLINGS -->
  <ebb-portal-dwelling-qualified-list
    [data]='currentDwellings'
    [currentUser]='currentUser'
    [textHomeownerDwellingQualified]='textHomeownerDwellingQualified'>
  </ebb-portal-dwelling-qualified-list>

  <div style="min-height: 50px;"></div>
</div>
